import React from 'react';

import PropTypes from 'prop-types';

import Section from '../WDS/Section/Section';
import Typography from '../WDS/Typography/Typography';

import styles from './FAQSection.scss';

const propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
};

function FAQSection(props) {
    const {
        children,
        title,
    } = props;

    function _augmentChildren(children) {
        return React.Children.map(children, (child) => !!child && (
            <div className={styles.faq}>
                {child}
            </div>
        )).filter(Boolean);
    }

    return (
        <Section aria-labelledby="faq-header-section">
            <Typography
                className={styles.faqHeader}
                component="h2"
                id="faq-header-section"
                variant="h3"
            >
                {title}
            </Typography>
            {_augmentChildren(children)}
        </Section>
    );
}

FAQSection.propTypes = propTypes;

export default FAQSection;
